<template>
  <section class="_menu-section-style">
    <form-section label="Opções do menu" v-model="isExpanded.menu">
      <MenuOptions 
        :sectionsId="sectionsId"
        :selectedSection="selectedSection"
      />
    </form-section>  

    <form-section label="Texto" v-model="isExpanded.text">
      <Texts 
        textType="text" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        :hide="['content', 'alignment']"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        :hide="['height']"
        @update="onUpdateBackground"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Logo" v-model="isExpanded.logo" :divider="false">
      <Logo 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :hide="['alignment']"
        @update="onUpdateLogo"
      />
    </form-section>
  </section>
</template>

<script>
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import Alignment from '../forms/formsV2/Alignment.vue'
import Logo from '../forms/formsV2/Logo.vue'
import MenuOptions from '../forms/formsV2/MenuOptions.vue'
import isEmpty from './isEmpty.vue'

export default {
  name: 'AppBarSection',
  components: { FormSection, Texts, Background, Logo, Alignment, MenuOptions, isEmpty},  
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {menu: true, text: true, bg: true, logo: true}    
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    onUpdateLogo ($event) {
      this.selectedSection['logo'] = $event['logo']
    }
  }      
}
</script>